// import {log} from "@/api/response" //请求后端做记录


const state = {
  statusList: {
    language: "zh",
  },
  // userMenu: {},
};

const mutations = {
  setStatusList(state, data) {
    if (!data) {
      state.statusList = {
        language: "zh",
      };
    } else {
      for (var key in data) {
        state.statusList[key] = data[key];
      }

    }

    // log(json).then((res)=>{
    //     console.log(res)
    //   }).catch(err => {
    //       // 报错
    //       console.log(err)
    //     })
  },
  // setUserMenu(state, data) {
  //   if (!data) {
  //     state.userMenu = {};
  //   } else {
  //     var json = {
  //       ...data,
  //     };
  //     state.userMenu = json;
  //   }
  // },
};

const actions = {};
export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
